import { useAtom } from '@reatom/npm-react'

import { PairMigrationStatus } from '../model'

import type { PairModel } from '../atoms'

export const usePairDevTokensInfo = (pair: PairModel) => {
  const [data] = useAtom(
    (ctx) => {
      const creatorStats = ctx.get(pair.creatorStats)

      if (!creatorStats) {
        return undefined
      }
      const migrationStatus = ctx.spy(pair.migrationStatus)
      const isMigrated = PairMigrationStatus.isMigrated(migrationStatus)

      const bondedPools = creatorStats.bondedPools ?? 0
      const bondedTokensWithoutCurrent = Math.max(
        0,
        isMigrated ? bondedPools - 1 : bondedPools,
      )

      const totalPoolsWithoutCurrent = Math.max(0, creatorStats.totalPools - 1)

      const topTokensWithoutCurrent = creatorStats.topTokens.filter(
        (token) => token.address !== pair.quote.address,
      )

      return {
        bondedTokensWithoutCurrent,
        totalPoolsWithoutCurrent,
        topTokensWithoutCurrent,
        isMigrated,
        creatorStats,
      }
    },
    [pair],
  )

  return data
}

export type PairDevTokensInfo = NonNullable<
  ReturnType<typeof usePairDevTokensInfo>
>
